import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  href: string;
  subtext?: string;
  className?: string;
  fullWidth?: boolean;
  size?: 'md' | 'lg';
};
const sizes = {
  md: 'px-5 py-3 text-sm',
  lg: 'px-6 py-3.5 text-sm md:px-8 md:py-4 md:text-base'
};
export function Button({
  children,
  href,
  subtext,
  className = '',
  fullWidth,
  size = 'md'
}: ButtonProps) {
  const external = !href.startsWith('#');
  return <motion.a href={href} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} whileTap={{
    scale: 0.98
  }} transition={{
    duration: 0.12,
    ease: [0.23, 1, 0.32, 1]
  }} className={`inline-flex flex-col items-center justify-center rounded-xl border-b-4 border-brand-dark bg-brand text-center font-display font-black uppercase tracking-wide text-white shadow-lg shadow-brand/30 transition-colors duration-150 ease-out hover:bg-brand-dark focus:outline-none focus:ring-4 focus:ring-brand-light/50 ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-232" data-mp="1sizqs4rlpe4c">
      <span className="flex items-center gap-2" data-id="element-233" data-mp="er7etldrfu92">
        {children}
        <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-234" data-mp="tn6wnnqo98re" />
      </span>
      {subtext && <span className="mt-1 font-sans text-[11px] font-semibold normal-case tracking-normal text-white/90 md:text-xs" data-id="element-235" data-mp="onkfx4bmxadu">
          {subtext}
        </span>}
    </motion.a>;
}